/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for restore screen icon.
 *
 * @author Hari Gangadharan
 */
const RestoreScreen = props => (
  <SvgIcon {...props}>
    <path
      d="M6 6L1 6 1 9 7.5 9C8.329 9 9 8.328 9 7.5L9 1 6 1 6 6zM15 16.5L15 23 18 23 18 18 23 18 23 15 16.5
      15C15.671 15 15 15.672 15 16.5M7.5 15L1 15 1 18 6 18 6 23 9 23 9 16.5C9 15.672 8.329 15 7.5 15M18 6L18 1 15 1
      15 7.5C15 8.328 15.671 9 16.5 9L23 9 23 6 18 6z"
    />
  </SvgIcon>
);

export default RestoreScreen;



// WEBPACK FOOTER //
// ./src/js/icons/RestoreScreen.jsx